export default function () {
  const widgetName = "tier1MainFeatureButtons";
  const widgetOpts = tier1MainFeatureButtonsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 4,
    itemsPerPanel: 4,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    moreButton: false,
    buyNowButton: false,
    showDescription: false,
    textOverImage: false,
    link: ["all"],
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        customWidget(widgetData);
      }
    },
  });

  function customWidget(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { URL } = widgetData[x];
      let $button = $(this);
      $(this).addClass("button");

      if (URL == null) {
        $button.removeAttr("href");
      }
    });
  }
}
